const css = `._7xzila__restrictedComponent._7xzila__disabled{cursor:not-allowed}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"restrictedComponent":"_7xzila__restrictedComponent","disabled":"_7xzila__disabled"};
